import { StreamingLog } from 'data/domain/streaming-log'
import firebase, { db } from '../../infra/firebase'

export const addStreamingLog = (addStreamingLog: StreamingLog) => {
  return db.collection('streamingLog').add({
    ...addStreamingLog,
    createdAt: firebase.firestore.FieldValue.serverTimestamp()
  })
}
